// src/components/resources/tools/generators/SubtitleOverlay/form-value-converters.ts
//
// Local form-value converters for the Subtitle Overlay generator's <FormField>.
// These are NOT the shared `~/lib/utils/form-values` guards: `safeStringValue`
// COERCES numbers/booleans to their string form (the shared `getString` returns
// `''` for a non-string), and `safeNumberValue` returns a *string* (parsed,
// `''` on NaN/empty) rather than a `number`. Swapping to the shared helpers would
// change rendered output, so they stay local — verbatim moves of the former
// in-component closures.

/**
 * Safely converts a value to string, handling null/undefined cases
 */
export const safeStringValue = (val: unknown): string => {
  if (val === null || val === undefined) return ''
  if (typeof val === 'string') return val
  if (typeof val === 'number' || typeof val === 'boolean') return String(val)
  return ''
}

/**
 * Safely converts a value to number, handling null/undefined cases
 */
export const safeNumberValue = (val: unknown): string => {
  if (val === null || val === undefined) return ''
  if (typeof val === 'number') return String(val)
  if (typeof val === 'string' && val.trim() !== '') {
    const num = parseFloat(val)
    return isNaN(num) ? '' : String(num)
  }
  return ''
}
